import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ProfileService} from 'app/views/profile/services/profile.service';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';

declare const html2canvas: any;
declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'change-waiver-settings-modal',
    templateUrl: './change-waiver-settings-modal.component.html',
    styleUrls: ['./change-waiver-settings-modal.component.scss']
})
export class ChangeWaiverSettingsModalComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;
    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    signaturePadOptions = {
        'minWidth': 5,
        'canvasWidth': 600,
        'canvasHeight': 250,
        'backgroundColor': 'rgb(255, 255,255)'
    };
    showModal = false;
    data = null;
    disabledSubmit = false;
    step = 'get-consent';
    drawnSignature = '';
    chosenFont = '';
    userName = '';
    pathToPDF = '';
    pdfPage = 1;
    currentPdfMaxPage = 1;
    zoom = 0.9;
    spinnerShow = false;
    signatureDrawn = false;

    fontList = [
        'Dancing Script',
        'Kaushan Script',
        'Great Vibes',
        'Sacramento',
        'Marck Script',
        'Nothing You Could Do'
    ];

    constructor(
        public api: ApiClientService,
        public profile: ProfileService,
        public urlService: UrlService
    ) {
    }

    ngOnInit() {
        this.userName = this.profile.data.userProfile.fullName;
        setTimeout( () => this.showModal = true, 300);
        this.profile.onConsentUpdated.subscribe(data => {
            if(data.created) {
                this.step = 'show-filled-form';
                this.pathToPDF = data.consent.pathToPdf;
                this.profile.data.consent = data.consent;
            } else
                this.hideModal();
            this.spinnerShow = false;
            this.disabledSubmit = false;
        });
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.profile.showChangeWaiverSettingsModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.profile.showChangeWaiverSettingsModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    createResidentConsent() {
        const resident = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        const data = {
            user: resident.residentBdId,
            base64string: this.drawnSignature ? this.drawnSignature : undefined,
            text: this.userName,
            font: this.chosenFont ? this.chosenFont : undefined
        };
        this.disabledSubmit = true;
        this.spinnerShow = true;

        this.profile.saveResidentConsentDetails(true, data);
    }

    removeResidentConsent() {
        if(this.profile.data.consent) {
            this.spinnerShow = true;
            this.disabledSubmit = true;
            this.profile.saveResidentConsentDetails(false, null);
        } else
            this.hideModal();
    }

    changeSignatureType(type) {
        this.step = type;
        this.chosenFont = null;
        this.drawnSignature = null;
    }

    drawStart() {
        this.signatureDrawn = true;
    }

    drawComplete() {
        if(this.signatureDrawn) {
            this.setDrawnSignature(this.signaturePad.toDataURL('image/jpeg'));
            this.step = 'signature-confirmation';
        } else
            toastr.warning('Signature is required to continue');
    }

    drawClear() {
        this.drawnSignature = null;
        this.signaturePad.clear();
    }

    onPdfLoaded(event) {
        this.currentPdfMaxPage = event.pdfInfo.numPages;
    }

    chooseFont() {
        if(!this.chosenFont)
            toastr.warning('Font must be chosen to continue');
        else
            this.step = 'signature-confirmation';
    }

    setDrawnSignature(sign: string) {
        this.drawnSignature = sign.replace('data:image/jpeg;base64,', '');
    }

    onChosenFont(font: string, element: string) {
        const el = document.getElementById(element);
        if (el) {
            this.chosenFont = font;

            html2canvas(el).then((canvasElement) => {
                this.setDrawnSignature(canvasElement.toDataURL('image/jpeg'));
            });
        }
    }

    zoomIn() {
        this.zoom += 0.1;
    }

    zoomOut() {
        if(this.zoom >= 0.2)
            this.zoom -= 0.1;
    }

    previousPage() {
        if(this.pdfPage > 0)
            this.pdfPage -= 1;
    }

    nextPage() {
        if(this.pdfPage < this.currentPdfMaxPage)
            this.pdfPage += 1;
    }

    ngOnDestroy() {
        this.profile.onConsentUpdated.observers = [];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/profile/change-waiver-settings-modal/change-waiver-settings-modal.component.ts